import intersect from '@alpinejs/intersect';
import ajax from '@imacrayon/alpine-ajax';
import masonry from 'alpinejs-masonry';

import { Alpine } from '@webikon/webentor-core/_alpine';

// Extend Alpine with more components, plugins, etc.
document.addEventListener('alpine:init', () => {
  Alpine.data('heroKenBurns', function () {
    return {
      init() {
        // Trigger the zoom-out transition on next frame after load
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            (this.$el as HTMLElement).classList.add('is-loaded');
          });
        });
      },
    };
  });

  Alpine.data('siteHeader', function () {
    const SCROLL_THRESHOLD = 80;
    const HERO_SELECTOR = '.has-hero, .hero, [data-hero]';

    return {
      scrolled: false,
      menuOpen: false,

      init() {
        const hasHero = !!document.querySelector(HERO_SELECTOR);
        this.scrolled = !hasHero || window.scrollY > SCROLL_THRESHOLD;

        window.addEventListener(
          'scroll',
          () => {
            this.scrolled =
              !document.querySelector(HERO_SELECTOR) ||
              window.scrollY > SCROLL_THRESHOLD;
          },
          { passive: true },
        );
      },

      toggleMenu() {
        this.menuOpen = !this.menuOpen;
        document.body.style.overflow = this.menuOpen ? 'hidden' : '';
      },

      closeMenu() {
        this.menuOpen = false;
        document.body.style.overflow = '';
      },
    };
  });

  Alpine.data('menu', function () {
    return {
      __type: 'menu',
      open: false,
      isTouch: false,
      init() {},
      openPopover(id: string) {
        this.open = id;
      },
      closePopover() {
        this.open = false;
      },
      toggle(id: string) {
        if (this.open === id) {
          this.open = false;
        } else {
          this.open = id;
        }
      },
    };
  });

  Alpine.plugin(ajax);
  Alpine.plugin(intersect);
  Alpine.plugin(masonry);
});
